module.exports = __webpack_public_path__ + "static/usc.2e77697f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/usc.png
// module id = 2209
// module chunks = 61762850755587